import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { unregister } from "./registerServiceWorker";
import { ChakraProvider, CSSReset, ColorModeScript } from "@chakra-ui/react";
import { theme } from "@chakra-ui/react";
import { APP_BASE_PATH } from "./appConfig";

// Load the base path from the app config - orginally it was set to:
// document.getElementsByTagName("base")[0].getAttribute("href");
const baseUrl =
  APP_BASE_PATH !== ""
    ? APP_BASE_PATH
    : document.getElementsByTagName("base")[0].getAttribute("href");
const rootElement = document.getElementById("root");

ReactDOM.render(
  <ChakraProvider theme={theme}>
    <CSSReset />
    <BrowserRouter basename={baseUrl}>
      <ColorModeScript initialColorMode={theme.config.initialColorMode} />
      <App />
    </BrowserRouter>
  </ChakraProvider>,
  rootElement
);

unregister();
